import { render, staticRenderFns } from "./AvailablePpaList.vue?vue&type=template&id=3181bdb2&"
import script from "./AvailablePpaList.vue?vue&type=script&lang=js&"
export * from "./AvailablePpaList.vue?vue&type=script&lang=js&"
import style0 from "./AvailablePpaList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports